// notify-me.js (clean)
// - Assumes Liquid only renders the Notify button when sold out
// - No visibility syncing / MutationObservers
// - Opens/closes modal and submits to your Cloudflare endpoint

(function () {
  function qs(sel, root = document) {
    return root.querySelector(sel);
  }
  function qsa(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function initNotifyForSection(sectionEl) {
    // Prevent double-init (Dawn can re-render sections / quick add)
    if (sectionEl.dataset.notifyInit === '1') return;
    sectionEl.dataset.notifyInit = '1';

    const openBtn = qs('[data-notify-open]', sectionEl);
    if (!openBtn) return;

    const sectionId = sectionEl.dataset.sectionId || '';

    // Modal lookup (prefer the one matching this section id)
    const modal =
      (sectionId && (qs(`#NotifyModal-${sectionId}`, sectionEl) || qs(`#NotifyModal-${sectionId}`))) ||
      qs('.notify-modal', sectionEl) ||
      qs('.notify-modal');

    if (!modal) return;

    const closeEls = qsa('[data-notify-close]', modal);
    const form = qs('[data-notify-form]', modal);
    const statusEl = qs('.notify-status', modal);

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      const emailInput = qs('input[name="email"]', modal);
      if (emailInput) emailInput.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (statusEl) statusEl.textContent = '';
      if (form) form.reset();
    }

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });

    closeEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (!form) return;

    // Variant id input (for including in message)
    const productForm =
      openBtn.closest('product-form') ||
      sectionEl.querySelector('product-form') ||
      document.querySelector('product-form');

    const variantIdInput = (productForm && qs('input[name="id"]', productForm)) || qs('input[name="id"]', sectionEl);

    // Prevent double-binding on the same form
    if (form.dataset.notifyBound === '1') return;
    form.dataset.notifyBound = '1';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (statusEl) statusEl.textContent = 'Submitting…';

      const email = (e.currentTarget.elements.email?.value || '').trim();
      if (!email) {
        if (statusEl) statusEl.textContent = 'Please enter a valid email.';
        return;
      }

      const variantId = variantIdInput ? variantIdInput.value : '';
      const productUrl = window.location.href;

      try {
        const res = await fetch('https://notify.babiemiueapi.com', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            variantId,
            productUrl,
            productTitle: document.title,
          }),
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        if (statusEl) statusEl.textContent = 'Got it — we will email you when it is back.';
        setTimeout(closeModal, 3000);
      } catch (err) {
        if (statusEl) statusEl.textContent = 'Something went wrong. Please try again.';
      }
    });
  }

  function boot() {
    // Initialize each Notify button’s nearest section wrapper
    qsa('[data-notify-open]').forEach((btn) => {
      const root = btn.closest('[data-section-id]') || document.body;
      initNotifyForSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor / dynamic section reloads
  document.addEventListener('shopify:section:load', boot);
})();
